export default function getLatest(items, empty = '') {
  return (items
    ? (items[Object.keys(items).sort((a, b) => b - a)[0]] || empty)
    : empty);
}
